import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "60",
  height: "60",
  rx: "30",
  fill: "white",
  "fill-opacity": "0.12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0.5",
  y: "0.5",
  width: "59",
  height: "59",
  rx: "29.5",
  stroke: "white",
  "stroke-opacity": "0.32"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "30",
  cy: "30",
  r: "20",
  fill: "#121926"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M30 6.5C42.9786 6.5 53.5 17.0213 53.5 30C53.5 42.9786 42.9786 53.5 30 53.5C17.0213 53.5 6.5 42.9786 6.5 30C6.5 17.0213 17.0213 6.5 30 6.5ZM26.1602 20.7334C25.354 20.7334 24.7004 21.3872 24.7002 22.1934V37.8066C24.7003 38.0949 24.7856 38.3766 24.9453 38.6162C25.3925 39.287 26.2988 39.468 26.9697 39.0205L38.6797 31.2148C38.8397 31.108 38.9771 30.9705 39.084 30.8105V30.8096C39.5312 30.1388 39.3503 29.2323 38.6797 28.7852L26.9697 20.9785H26.9688C26.7292 20.8191 26.4479 20.7334 26.1602 20.7334Z",
  fill: "white",
  stroke: "#E5E5E8"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }